module.exports = __webpack_public_path__ + "static/img/homes7.dbdc68d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/images/home/homes7.png
// module id = 7R56
// module chunks = 2